<template>
  <div>
    <v-snackbar color="deep-orange"
                right
                top
                v-model="validationSnackbar">
      {{ $t('thereAreItemsThatRequireYourAttention') }}
    </v-snackbar>

    <top-header v-bind:title="$t('newCategory')">
      <header-button icon="mdi-close"
                     slot="left-button"
                     v-bind:label="$t('cancel')"
                     v-bind:to="{ name: 'learning-categories' }" />
      <header-button icon="mdi-check"
                     right
                     slot="right-button"
                     v-bind:label="$t('save')"
                     v-on:click="createCategory" />
    </top-header>

    <v-progress-linear indeterminate
                       v-bind:active="loading" />

    <v-container>
      <v-row>
        <v-col cols="12"
               lg="6">
          <category-details-card ref="categoryDetailsCard"
                                v-bind:category="category" />
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
  import { mapActions } from 'vuex'

  import HeaderButton from '@/components/common/HeaderButton.vue'
  import TopHeader from '@/components/common/TopHeader.vue'
  import CategoryDetailsCard from '@/components/learning/CategoryDetailsCard.vue'

  export default {
    components: {
      HeaderButton,
      CategoryDetailsCard,
      TopHeader
    },
    data: () => ({
      loading: false,
      category: {},
      validationSnackbar: false
    }),
    methods: {
      async createCategory() {
        if (!this.$refs.categoryDetailsCard.validate()) {
          this.validationSnackbar = true

          return
        }

        await this.doCreateCategory({ category: this.category })

        this.$router.push({ name: 'learning-categories' })
      },
      ...mapActions({
        doCreateCategory: 'learning/createCategory'
      })
    },
    name: 'CategoryAdd'
  }
</script>

<i18n>
  {
    "de": {
      "cancel": "Abbrechen",
      "newCategory": "Neue Kategorie",
      "save": "Speichern",
      "thereAreItemsThatRequireYourAttention": "Es gibt Felder, die Ihre Aufmerksamkeit erfordern."
    },
    "en": {
      "cancel": "Cancel",
      "newCategory": "New category",
      "save": "Save",
      "thereAreItemsThatRequireYourAttention": "There are items that require your attention."
    }
  }
</i18n>